//templates
export const EMAIL_TEMPLATES_SET_TEMPLATES = 'EMAIL_TEMPLATES_SET_TEMPLATES';
export const EMAIL_TEMPLATES_UPDATE_TEMPLATE = 'EMAIL_TEMPLATES_UPDATE_TEMPLATE';
export const EMAIL_TEMPLATES_REPLACE_TEMPLATE = 'EMAIL_TEMPLATES_REPLACE_TEMPLATE';


// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/flow/emailTemplateFlow/actionType.js